import { useState } from 'react'
import { useGameStore } from '@/store/gameState'
import styles from './DebugMenu.module.css'

const ENERGY_AMOUNTS = [5, 10, 25, 50] as const

export function DebugMenu() {
  const [isOpen, setIsOpen] = useState(false)
  const addDebugEnergy = useGameStore((s) => s.addDebugEnergy)

  const handleAddEnergy = (amount: number) => {
    addDebugEnergy(amount)
    setIsOpen(false)
  }

  return (
    <div className={styles.container}>
      <button
        className={styles.trigger}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="menu"
      >
        Debug
      </button>

      {isOpen && (
        <div className={styles.menu} role="menu">
          <div className={styles.menuHeader}>Add Energy</div>
          {ENERGY_AMOUNTS.map((amount) => (
            <button
              key={amount}
              className={styles.menuItem}
              onClick={() => handleAddEnergy(amount)}
              role="menuitem"
            >
              +{amount} Energy
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
